import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Wordmark from "@/components/Wordmark";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/individual", label: "Individual" },
  { to: "/corporate", label: "Corporate" },
  { to: "/school", label: "School" },
  { to: "/yesteryear", label: "Yesteryear" },
  { to: "/education", label: "Education" },
  { to: "/gift-vouchers", label: "Gift" },
  { to: "/quiz", label: "Quiz" },
  { to: "/blog", label: "Journal" },
  { to: "/about", label: "About" },
  { to: "/gallery", label: "Gallery" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-40 bg-[#FDFBF7]/85 backdrop-blur-md border-b border-[#E5D9C5]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-link">
          <Wordmark />
        </Link>

        <nav className="hidden lg:flex items-center gap-5 xl:gap-6 ml-6 xl:ml-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[13px] xl:text-sm font-medium tracking-wide whitespace-nowrap transition-colors ${
                  isActive ? "text-[#6E2638]" : "text-[#1A1817] hover:text-[#6E2638]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block shrink-0">
          <Link to="/individual" className="btn-primary whitespace-nowrap text-sm px-5 py-2.5" data-testid="header-book-btn">
            Book a Tour
          </Link>
        </div>

        <button
          className="lg:hidden text-[#6E2638]"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E5D9C5] bg-[#FDFBF7]" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${
                    isActive ? "text-[#6E2638]" : "text-[#1A1817]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/individual"
              onClick={() => setOpen(false)}
              className="btn-primary mt-2 justify-center"
              data-testid="mobile-book-btn"
            >
              Book a Tour
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
